var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col-12" },
    _vm._l(_vm.faqArray, function (item, index) {
      return _c("div", { key: index, staticClass: "faqWrapper" }, [
        _c(
          "div",
          {
            staticClass: "px-2 questionWrapper",
            on: {
              click: function ($event) {
                return _vm.handleAnswerToShow(index)
              },
            },
          },
          [
            _c("span", { staticClass: "lead" }, [
              _vm._v(_vm._s(item.question)),
            ]),
            _vm._v(" "),
            !_vm.answersToShow.includes(index)
              ? _c("i", { staticClass: "fa fa-chevron-down" })
              : _vm._e(),
            _vm._v(" "),
            _vm.answersToShow.includes(index)
              ? _c("i", { staticClass: "fa fa-chevron-up" })
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.answersToShow.includes(index),
                expression: "answersToShow.includes(index)",
              },
            ],
            staticClass: "p-3",
          },
          _vm._l(item.answer, function (element) {
            return _c("div", [
              Array.isArray(element)
                ? _c(
                    "div",
                    _vm._l(element, function (li) {
                      return _c("ul", [_c("li", [_vm._v(_vm._s(li))])])
                    }),
                    0
                  )
                : _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.replacePlaceholder(element)),
                    },
                  }),
            ])
          }),
          0
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }